module.exports = __webpack_public_path__ + "img/rigidbody-properties.9b4b75f6.png";